import Vue from "vue";
import VueLazyload from "vue-lazyload";
import Picture from "../components/Picture.vue";
import { generateImageJpg, generateImageWebp } from "../utils/image";
Vue.use(VueLazyload);
Vue.component("www-picture", Picture);
Vue.prototype.$ossJpg = generateImageJpg;
Vue.prototype.$ossWebp = generateImageWebp;
Vue.prototype.$isMob = function () {
  return this.$store.state.isMobileSite;
};

Vue.prototype.$i18Id = function (str) {
  if (!str) {
    return "";
  }
  return str.replace(/[^\w\u4e00-\u9fa5]/g, "_").toLocaleLowerCase();
};



// WEBPACK FOOTER //
// ./src/plugins/lazyload.js